__turbopack_context__.v({
  "backBtn": "consentimiento-module__Czrvdq__backBtn",
  "bar": "consentimiento-module__Czrvdq__bar",
  "body": "consentimiento-module__Czrvdq__body",
  "btnPrimary": "consentimiento-module__Czrvdq__btnPrimary",
  "btnSecondary": "consentimiento-module__Czrvdq__btnSecondary",
  "bullet": "consentimiento-module__Czrvdq__bullet",
  "bulletIcon": "consentimiento-module__Czrvdq__bulletIcon",
  "bullets": "consentimiento-module__Czrvdq__bullets",
  "card": "consentimiento-module__Czrvdq__card",
  "closeBtn": "consentimiento-module__Czrvdq__closeBtn",
  "error": "consentimiento-module__Czrvdq__error",
  "footer": "consentimiento-module__Czrvdq__footer",
  "footerActions": "consentimiento-module__Czrvdq__footerActions",
  "header": "consentimiento-module__Czrvdq__header",
  "headerIcon": "consentimiento-module__Czrvdq__headerIcon",
  "headerLeft": "consentimiento-module__Czrvdq__headerLeft",
  "headerTitle": "consentimiento-module__Czrvdq__headerTitle",
  "overlay": "consentimiento-module__Czrvdq__overlay",
  "paso": "consentimiento-module__Czrvdq__paso",
  "pasoDetalle": "consentimiento-module__Czrvdq__pasoDetalle",
  "pasoIcono": "consentimiento-module__Czrvdq__pasoIcono",
  "pasoTexto": "consentimiento-module__Czrvdq__pasoTexto",
  "pasoTitulo": "consentimiento-module__Czrvdq__pasoTitulo",
  "pasos": "consentimiento-module__Czrvdq__pasos",
  "question": "consentimiento-module__Czrvdq__question",
  "text": "consentimiento-module__Czrvdq__text",
  "textoAcuse": "consentimiento-module__Czrvdq__textoAcuse",
  "titulo": "consentimiento-module__Czrvdq__titulo",
});
